/*
 * export interface for sales channel components
 * Author: Chris
 * CreatedAt: 2021-3-23
 */
import React from 'react';
import { useSalesChannelType } from '@/src/constrains/SalesChannelHOC/useSalesChannel';
import { currentSelectedStyle } from '@/src/constrains/SalesChannelStyleSelect/slice';
import { ChannelType, WebSiteSubType } from '@/src/types/common/SalesChannel';
import { useSelector } from 'react-redux';
import SalesChannelEditorPromotion from './SalesChannelEditorPromotion';
import SalesChannelEditorPromotionResponsive from './SalesChannelEditorPromotionResponsive';

export default (props) => {
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const isNative =
    useSelector(currentSelectedStyle()) === WebSiteSubType.NativeMobile;
  return isMini || isNative ? (
    <SalesChannelEditorPromotion />
  ) : (
    <SalesChannelEditorPromotionResponsive />
  );
};
